const cCollapse = () => {
  const collapseBlocks = document.querySelectorAll('.collapse')
  
  function returnIcon(name) {
    return `
      <svg width="26px" height="26px" viewbox="0 0 26 26" class="icon icon_block">
        <use xlink:href="#icon-${name}"></use>
      </svg>
    `
  }

  if ( collapseBlocks !== null && collapseBlocks.length ) {
  
    collapseBlocks.forEach((collapse, index, parent) => {
      const header = collapse.querySelector('.collapse__header')
      const body = collapse.querySelector('.collapse__body')
      const icon = collapse.querySelector('.collapse__icon')
  
      header.addEventListener('click', function () {
        if (collapse.classList.contains('is-open')) {
          collapse.classList.remove('is-open')
          body.setAttribute('style', `height: 0;`);
          icon.innerHTML = returnIcon('plus-circle')
          
        } else {
          collapse.classList.add('is-open')
          body.setAttribute('style', `height: ${body.querySelector('.collapse__content').clientHeight}px;`);
          icon.innerHTML = returnIcon('minus-circle')
        }
  
        // autoClose
        parent.forEach((el) => {
          if (!el.contains(header)) {
            el.classList.remove('is-open')
            el.querySelector('.collapse__body').setAttribute('style', `height: 0;`);
            el.querySelector('.collapse__icon').innerHTML = returnIcon('plus-circle')
          }
        })
      })
    })

  }

}

export default cCollapse
